import React from 'react';
import './style.css';
import {NavLink} from 'react-router-dom';
//import logo from '../../../../smile.svg';
const images = require("../../../../images.json");
const logo = images.logo

export default class SidebarComponent extends React.Component {
    render() {
        return (
            <div className="Sidebar">
                <aside className="menu">
                            <div className="logo">
                                <img alt="logo" src={logo} />
                            </div>
                    <div className="menu-content">
                        <p className="menu-label">
                            Menu
                        </p>
                        <ul className="menu-list">
                            <li><NavLink activeClassName="is-active" to="/home">Citas</NavLink></li>
                            <li><NavLink activeClassName="is-active" to="/registers">Registros de clientes</NavLink></li>
                        </ul>
                        {(this.props.user.role === "admin" || this.props.user.role === "developer") &&
                        <p className="menu-label">
                            Administrador
                        </p>}
                        {(this.props.user.role === "admin" || this.props.user.role === "developer") &&
                        <ul className="menu-list">
                            <li><NavLink activeClassName="is-active" to="/create-account">Cuentas</NavLink></li>
                            <li><NavLink activeClassName="is-active" to="/movements">Movimientos</NavLink></li>
                            <li><NavLink activeClassName="is-active" to="/doctors">Empleado</NavLink></li>
                            <li><NavLink activeClassName="is-active" to="/diagnostics">Servicios</NavLink></li>
                        </ul>}
                        {this.props.user.role === "developer" &&
                        <p className="menu-label">
                            Desarrollador
                        </p>}
                        {this.props.user.role === "developer" &&
                        <ul className="menu-list">
                            <li><NavLink activeClassName="is-active" to="/add-json">Opciones de desarrollador</NavLink></li>
                        </ul>}
                    </div>
                </aside>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/components/sidebar/index.js